"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_NOTIFICATION = void 0;
exports["default"] = setNotification;

var _uniqueID = _interopRequireDefault(require("../utils/uniqueID"));

var SET_NOTIFICATION = 'WEB_CHAT/SET_NOTIFICATION';
exports.SET_NOTIFICATION = SET_NOTIFICATION;

function setNotification(_ref) {
  var alt = _ref.alt,
      data = _ref.data,
      id = _ref.id,
      level = _ref.level,
      message = _ref.message;

  if (!id || typeof id !== 'string') {
    console.warn('botframework-webchat: The "id" argument passed to "setNotification" must be a string; defaulting to a random value.');
    id = (0, _uniqueID["default"])();
  }

  if (!level || typeof level !== 'string') {
    console.warn('botframework-webchat: The "level" argument passed to "setNotification" must be a string; defaulting to "info".');
    level = 'info';
  }

  return {
    type: SET_NOTIFICATION,
    payload: {
      alt: alt,
      data: data,
      id: id,
      level: level,
      message: message
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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